import React from 'react';
import { graphql } from 'gatsby';
import ProductDetailMasthead from './ProductDetailMasthead';
import {
    KontentRadioMultiChoice,
    BrandColor,
    KontentNumberValue,
    KontentStringValue,
    KontentMedia,
    KontentStringCodenameValue,
    KontentRichText,
} from '../../../types/KontentProps';

export type ContentPosition = 'left' | 'center' | 'right';
export type VerticalPosition = 'top' | 'center' | 'bottom';
export interface ProductDetailProps {
    product_name_position: KontentRadioMultiChoice<ContentPosition>;
    text_background_color: BrandColor;
    text_background_opacity: KontentNumberValue;
    under_image_bar_color: BrandColor;
    under_image_bar_show_hide: KontentRadioMultiChoice<'show' | 'hide'>;
    display_headline: KontentStringValue;
    display_sub_headline?: KontentStringValue;
    general_large___small_image_selection__large: KontentMedia;
    general_large___small_image_selection__small: KontentMedia;
    tablet_image: KontentMedia;
    vertical_alignment: KontentRadioMultiChoice<VerticalPosition>;
    display_headline_tag: KontentStringCodenameValue;
    display_sub_headline_tag?: KontentStringCodenameValue;
    description_copy?: KontentStringValue;
    description_tag?: KontentStringCodenameValue;
}

const ProductDetailMastheadContainer: React.FC<ProductDetailProps> = ({
    ...props
}) => {
    return <ProductDetailMasthead {...props} />;
};

export default ProductDetailMastheadContainer;

export const fragmentProductDetailMasthead = graphql`
    fragment ProductDetailMasthead on kontent_item_component___product_detail_masthead {
        elements {
            product_name_position {
                value {
                    codename
                }
            }
            text_background_color {
                ...kontentColor
            }
            text_background_opacity {
                value
            }
            under_image_bar_color {
                name
            }
            under_image_bar_show_hide {
                value {
                    codename
                }
            }
            display_headline {
                value
            }
            display_sub_headline_tag {
                value {
                    name
                    codename
                }
            }
            display_headline_tag {
                value {
                    name
                    codename
                }
            }
            display_sub_headline_tag {
                value {
                    codename
                    name
                }
            }
            description_copy {
                value
            }
            description_tag {
                value {
                    codename
                    name
                }
            }
            general_large___small_image_selection__large {
                ...kontentImage
                value {
                    ... on kontent_item_media___image {
                        id
                        elements {
                            file {
                                value {
                                    fluid(maxWidth: 1920, maxHeight: 988) {
                                        ...KontentAssetFluid
                                    }
                                }
                            }
                        }
                    }
                }
            }
            general_large___small_image_selection__small {
                ...kontentImage
                value {
                    ... on kontent_item_media___image {
                        id
                        elements {
                            file {
                                value {
                                    fluid(maxWidth: 720, maxHeight: 1080) {
                                        ...KontentAssetFluid
                                    }
                                }
                            }
                        }
                    }
                }
            }
            tablet_image {
                ...kontentImage
                value {
                    ... on kontent_item_media___image {
                        id
                        elements {
                            file {
                                value {
                                    fluid(
                                        maxWidth: 1024
                                        maxHeight: 1366
                                        quality: 100
                                    ) {
                                        ...KontentAssetFluid
                                    }
                                }
                            }
                        }
                    }
                }
            }
            vertical_alignment {
                value {
                    codename
                }
            }
        }
    }
`;
